import { Arrow } from "components/atoms/svgs/Arrow";
import { mobile } from "components/templates/Breakpoints";
import React from "react";
import styled from "styled-components";
import { color } from "styles/colours";
import { Text, types } from "react-bricks/frontend";
import TextBlock from "../common/TextBlock";

export interface AccordionItemProps {
  activeIndex?: number | null;
  setActiveIndex?: (index: number | null) => void;
  index?: number;
  title?: string;
  content?: string;
}

export const AccordionItem: types.Brick<AccordionItemProps> = ({
  activeIndex,
  setActiveIndex,
  index,
}) => {
  const isOpen = index === activeIndex;

  const toggle = () => {
    if (setActiveIndex) {
      setActiveIndex(isOpen ? null : index!);
    }
  };

  return (
    <StyledAccordionItem>
      <StyledAccordionTitle onClick={toggle}>
        <StyledArrow isOpen={isOpen} />
        <StyledAccordionButton onClick={toggle}>
          <Text
            propName="title"
            placeholder="Accordion Title"
            renderBlock={({ children }) => <>{children}</>}
          />
        </StyledAccordionButton>
      </StyledAccordionTitle>
      <Content isOpen={isOpen}>
        <TextBlock
          propName="content"
          placeholder="Accordion text"
          fontSize="1rem"
          lineHeight="1.6rem"
        />
      </Content>
    </StyledAccordionItem>
  );
};

AccordionItem.schema = {
  name: "accordion-item",
  label: "Accordion Item",
  category: "Accordion Components",
  hideFromAddMenu: true,

  getDefaultProps: () => ({
    title: "Accordion Title",
    content: "Accordion content goes here.",
  }),

  sideEditProps: [],
};

const StyledAccordionItem = styled.div`
  border: 2px solid ${color.S3100};
  border-radius: 8px;
  overflow: hidden;
`;

const StyledAccordionTitle = styled.div`
  background: ${color.S3100};
  min-height: 3rem;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0.5rem 1.875rem;
  cursor: pointer;

  ${mobile} {
    padding: 0.5rem;
  }
`;

const StyledArrow = styled(Arrow)<{ isOpen: boolean }>`
  ${({ isOpen }) => isOpen && `transform: rotate(90deg);`}
  transition: transform 0.2s ease-in-out;
  margin-right: 1rem;
  flex-shrink: 0;
  cursor: pointer;
`;

const StyledAccordionButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  font-size: 1.25rem;
  font-weight: 700;
  color: white;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 1rem;
  cursor: pointer;
  text-align: left;
  @media (max-width: 300px) {
    font-size: 0.875rem;
  }
`;

const Content = styled.div<{ isOpen: boolean }>`
  background: ${color.S310};
  padding: 1.5rem;
  display: ${(p) => (p.isOpen ? "block" : "none")};
`;
